import React from 'react';

import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import classnames from 'classnames';

import { useMaterialSwipeableDrawer, withWidget } from '@ezbobdev/ui-commons';
import { useTranslation } from '@ezbobdev/ui-framework';

import MaterialButton from '../MaterialButton/MaterialButton';
import MaterialTypography from '../MaterialTypography/MaterialTypography';
import { StyledDrawer, TriggerButtonBox } from './MaterialSwipeableDrawer.styled';

function MaterialSwipeableDrawer(props) {
  const { name } = props;

  const { i18n, t } = useTranslation();

  const { isDrawerOpen, setCloseIconRef, setIsDrawerOpen, anchor, ctaAlignSelf, hideBackdrop, iconSrc, hasTopBorder } =
    useMaterialSwipeableDrawer(props, MaterialSwipeableDrawer.displayName);

  return (
    <>
      <TriggerButtonBox $hasTopBorder={hasTopBorder}>
        <MaterialButton
          className="drawerButtonOpenDrawer"
          variant="text"
          fullWidth={false}
          onClick={() => setIsDrawerOpen(true)}
          startIcon={<img src={iconSrc} alt="" aria-hidden="true" />}
        >
          <MaterialTypography variant="button">{t(`${name}.triggerButtonLabel`)}</MaterialTypography>
        </MaterialButton>
      </TriggerButtonBox>

      <StyledDrawer
        $ctaAlignSelf={ctaAlignSelf}
        className={classnames(MaterialSwipeableDrawer.displayName, { drawerOpen: isDrawerOpen })}
        data-testid={MaterialSwipeableDrawer.displayName}
        hideBackdrop={hideBackdrop}
        anchor={anchor}
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      >
        <div className="drawerContent" role="presentation">
          <IconButton
            ref={setCloseIconRef}
            aria-label={t('globals.closeDrawerAriaLabel')}
            className="drawerCloseIcon"
            onClick={() => setIsDrawerOpen(false)}
          >
            <Close />
          </IconButton>

          <div className="drawerTitle">
            <img src={iconSrc} alt="" aria-hidden="true" />
            <MaterialTypography variant="button">
              {i18n.exists(`${name}.title`) ? t(`${name}.title`) : t(`${name}.triggerButtonLabel`)}
            </MaterialTypography>
          </div>

          <MaterialTypography variant="body1">{t(`${name}.content`)}</MaterialTypography>

          <MaterialButton className="ctaButton" variant="outlined" onClick={() => setIsDrawerOpen(false)}>
            {t(`${name}.ctaButtonLabel`)}
          </MaterialButton>
        </div>
      </StyledDrawer>
    </>
  );
}

MaterialSwipeableDrawer.displayName = 'MaterialSwipeableDrawer';

export default React.memo(withWidget(MaterialSwipeableDrawer));
